// @ts-nocheck
import { FormContext, formContextInitialValue } from "@store/Framework/Components/FormContext/FormContext";
import { FormModel } from "@store/Framework/Store/Starter/Components/Form/FormTypes";
import React, { FC, PropsWithChildren } from "react";

export interface FormContextProviderProps {
    form: FormModel | null;
}

export const FormContextProvider: FC<PropsWithChildren<FormContextProviderProps>> = ({ form, children }) => {
    return <FormContext.Provider value={form || formContextInitialValue}>{children}</FormContext.Provider>;
};
